<template>
  <div>
    <div class="mt-3 container-bg-white">
      <Filters :isAdmin="isAdmin"
               :companyId="companyId"
               :params="params"
               :filterOptions="filter_options"
               :showStatuses="true"
               @filterValues="filterValues"/>
    </div>
    <div class="mt-3 container-bg-white">
      <div class="row p-3">
        <div class="col-12 col-md-6">
          <h3 class="pl-0 mt-0 mb-1">{{ $t("flexben.requests.new_requests") }}</h3>
        </div>
        <div class="col-6 col-md-3">
          <input type="text"
                 v-model="searchString"
                 v-on:keyup.enter="search()"
                 :placeholder="$t('flexben.general.search')"
                 class="formedituser search-input float-right"/>
        </div>

        <div v-if="isAdmin" class="col-6 col-md-3">
          <input type="text" @keyup.enter="searchCode()" v-model="searchClientCode"
                 :placeholder="$t('flexben.general.search_client_code')"
                 class="formedituser search-input float-right"/>
        </div>
        <div class="col-12">
          <div class="table-responsive hover-table">
            <table class="table table-flx table-striped">
              <thead>
              <tr>
                <td class="w-25-p"><input type="checkbox" id="check_all" v-model="checkedAllModel" @change="checkAll()">
                </td>
                <td class="cursor-pointer" @click="sortBy('id')">
                  {{ $t("flexben.requests.table.header.number") }}
                  <img src="@/assets/images/arrow-down-fill.svg"
                       :class="{'rotate-180':(sortByField === 'id' && reverseSort)}"/>
                </td>
                <td class="cursor-pointer" @click="sortBy('placed_at')">
                  {{ $t("flexben.requests.table.header.placed_on") }}
                  <img src="@/assets/images/arrow-down-fill.svg"
                       :class="{'rotate-180':(sortByField === 'placed_at' && reverseSort)}"/>
                </td>
                <td>{{ $t("flexben.requests.table.header.beneficiary") }}</td>
                <td class="w-120-p">{{ $t("flexben.requests.table.header.beneficiary_cnp") }}</td>
                <td v-if="isAdmin">{{ $t("flexben.requests.table.header.client") }}</td>
                <td>{{ $t("flexben.requests.table.header.platform_source") }}</td>
                <td>{{ $t("flexben.requests.table.header.ticket_value") }}</td>
                <td>{{ $t("flexben.requests.table.header.ticket_count") }}</td>
                <td>{{ $t("flexben.requests.table.header.benefit") }}</td>
                <td class="cursor-pointer" @click="sortBy('total_value')">
                  {{ $t("flexben.requests.table.header.amount") }}
                  <img src="@/assets/images/arrow-down-fill.svg"
                       :class="{'rotate-180':(sortByField === 'total_value' && reverseSort)}"/>
                </td>
                <td>{{ $t("flexben.requests.table.header.taxes") }}</td>
                <td v-if="companySettings.gross_budget_taxation">
                  {{ $t("flexben.beneficiary_pages.requests.table.gross_amount") }}
                </td>
                <td>{{ $t("flexben.requests.table.header.status") }}</td>
              </tr>
              </thead>
              <tbody>
              <template v-if="requests.length >0">
                <tr class="trhover"
                    v-for="(request, index) in requests" :key="index">
                  <td class="w-25-p">
                    <input :checked="checkedRequests.ids.includes(request.id)" type="checkbox"
                           @change="toggleCheck(index)"/>
                  </td>
                  <td>{{ request.id }}</td>
                  <td>{{ moment(request.placed_at, 'DD/MM/YYYY HH:mm') }}</td>
                  <td>{{ request.employee_name }}</td>
                  <td class="w-120-p">{{ request.employee_cnp }}</td>
                  <td v-if="isAdmin">{{ request.company_name }}</td>
                  <td> {{request.platform_source}}</td>
                  <td> {{request.ticket_value}}</td>
                  <td> {{request.ticket_count}}</td>
                  <td>
                    <span :style="{backgroundColor: request.benefit_color}" class="color-bullet mr-1"></span>
                    {{ request.benefit_name }}
                    <span v-if="request.event !== null"> - {{ (request.event.type ==='LEGISLATED') ? $t('flexben.general.legal_events.'+request.event.name) : request.event.name }}</span>
                  </td>
                  <td>{{ request.total_value }} Lei</td>
                  <td>{{ (request.total_value > 0) ?
                    ((request.total_value_cas+request.total_value_cass+request.total_value_tax).toFixed(2)+' Lei') :
                    '-'}}
                  </td>
                  <td v-if="companySettings.gross_budget_taxation">
                    {{ calculateTotal(request).toFixed(2) }} Lei
                  </td>
                  <td>
                    <span class="beneficiary-request-status"
                            :class="'flx-'+request.status">{{ $t('flexben.requests.summary.status.' + request.status) }}
                    </span>
                  </td>
                  <td class="w-60-p" v-if="request.status !== 'new'">
                    <button class="btn action-button" @click="showDetails(index)">
                      {{$t("flexben.general.btn.see_more")}}
                    </button>
                  </td>
                </tr>
              </template>
              <template v-else>
                <tr class="gri-cell text-center trhover">
                  <td :colspan="100" class="text-center">{{ $t("flexben.general.no_results_found") }}
                  </td>
                </tr>
              </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div v-show="!showDetailsForm" class="mt-3 container-bg-white">
      <RequestsSummary :isAdmin="isAdmin"
                       :summaryList="checkedRequests.summaryList"
                       :checkedIds="checkedRequests.ids"
                       :key="requestSummaryKey"
                       :showPlaceOrderBtn="true"
                       :showTotalValue="true"
                       @reRenderList="reRenderList()"
                       @placeOrder="placeOrder()"/>
    </div>
    <div>
      <a class="btn text-themed go-back" @click="hideDetails()">{{ $t("flexben.general.go_back") }}</a>
      <component v-if="showDetailsForm"
                 :is="subTypeTemplate"
                 :isAdmin="isAdmin"
                 :detailsId="detailsId"
                 :companyId="companyId"
                 @hideDetails="hideDetails"></component>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import httpFlexbenService from "@/http/http-flexben";
import ValidationFailedRequestDetails from "@/components/flexben/requests/top_up/ValidationFailedRequestDetails";
import BouErrorRequestDetails from "@/components/flexben/requests/top_up/BouErrorRequestDetails";
import AwaitCallbackRequestDetails from "@/components/flexben/requests/top_up/AwaitCallbackRequestDetails";
import RequestsSummary from "@/components/flexben/requests/partials/RequestsSummary";
import Filters from "@/components/flexben/requests/partials/Filters";

export default {
  name: "ListAllRequests",
  components: {
    ValidationFailedRequestDetails,
    BouErrorRequestDetails,
    AwaitCallbackRequestDetails,
    RequestsSummary,
    Filters,
  },
  props: {
    isAdmin: {
      type: Boolean,
      default: false,
      required: true,
    },
    companyId: {
      type: Number,
    },
  },
  data: function () {
    return {
      httpService: httpFlexbenService.requests,
      dateFormat: 'dd/MM/yyyy',
      filter_options: {
        benefits: [],
        benefit_groups: [],
        companies: [],
        beneficiaries: [],
        company_addresses: [],
        departments: [],
        cost_centers: [],
        working_points: [],
        job_title_list: [],
      },
      searchString: '',
      searchClientCode: '',
      reverseSort: false,
      sortByField: null,
      params: {
        benefit: null,
        company: null,
        beneficiary: null,
        company_address: null,
        department: null,
        cost_center: null,
        working_point: null,
        job_title: null,
        benefit_group: null,
        start_date: null,
        end_date: null,
        only_list: null,
        sort_by: null,
        sort_direction: null,
        selected_platform: null,
        search_client_code: null,
      },
      companySettings: {
        cam_budget_taxation: false,
        gross_budget_taxation: false,
        up_dejun_auto: false,
        up_gift_auto: false
      },
      requests: {},
      checkedRequests: {
        ids: [],
        summaryList: {}
      },
      detailsId: null,
      detailsType: null,
      showDetailsForm: false,
      requestSummaryKey: 0,
      checkedAllModel: false,
      subTypeTemplates: {
        validation_failed: 'ValidationFailedRequestDetails',
        bou_error: 'BouErrorRequestDetails',
        await_callback: 'AwaitCallbackRequestDetails',
      },
      subTypeTemplate: null
    };
  },
  created() {
    this.params.company = this.companyId;
    this._loadList();
  },
  methods: {
    setGeneralData() {
      this.$emit('setGeneralData');
    },
    sortBy(fieldName) {
      if (this.sortByField !== fieldName) {
        this.reverseSort = false;
      }
      this.params.sort_by = fieldName;
      this.params.sort_direction = !this.reverseSort ? 'asc' : 'desc';
      this._loadList(this.params)
      this.sortByField = fieldName;

      this.reverseSort = !this.reverseSort;
    },
    changePerPage(perPage) {
      this.params.page = 1;
      this.params.perPage = perPage;
      this._loadList();
    },
    pageChanged(pageNb) {
      this.params.page = pageNb;
      this._loadList();
    },
    search() {
      if (this.searchString.length >= 3) {
        this.resetFilters();
        this.params.search = this.searchString;
        this._loadList();
      } else if (this.searchString.length === 0) {
        this.resetFilters();
        this.params.search = null;
        this._loadList();
      }
    },
    searchCode() {
      if (this.searchClientCode.length >= 1) {
        this.resetFilters();
        this.params.search_client_code = this.searchClientCode;
        this._loadList();
      } else if (this.searchClientCode.length === 0) {
        this.resetFilters();
        this.params.search_client_code = null;
        this._loadList();
      }
    },
    moment(date, format) {
      return moment(date).format(format);
    },
    filterValues() {
      this.checkedRequests = {
        ids: [],
        indexes: [],
        addresses: {},
        summaryList: {}
      };

      this.checkedAllModel = false;

      this.requestSummaryKey++;
      if (this.isAdmin) {
        this.$emit('setQuickFilterCompany', (this.params.company !== null) ? parseInt(this.params.company) : null);
      }
      this._loadList();
    },
    toggleCheck(index, triggerRerender = true) {
      const request = this.requests[index];

      if (this.checkedRequests.ids.includes(request.id)) {
        this.checkedRequests.ids.splice(this.checkedRequests.ids.indexOf(request.id), 1);

        delete this.checkedRequests.summaryList[request.company_id].benefits[request.benefit_id].values[request.id];

        if (!this.checkNotEmptyObj(this.checkedRequests.summaryList[request.company_id].benefits[request.benefit_id].values)) {
          delete this.checkedRequests.summaryList[request.company_id].benefits[request.benefit_id];
        }

        if (!this.checkNotEmptyObj(this.checkedRequests.summaryList[request.company_id].benefits)) {
          delete this.checkedRequests.summaryList[request.company_id];
        }
      } else {
        this.checkedRequests.ids.push(request.id);
        let companyObj;
        if (request.company_id in this.checkedRequests.summaryList) {
          companyObj = {...this.checkedRequests.summaryList[request.company_id]};
        } else {
          companyObj = {
            name: request.company_name,
            benefits: {}
          };
        }
        if (request.benefit_id in companyObj.benefits) {
          companyObj.benefits[request.benefit_id]['values'][request.id] = request.total_value;
        } else {
          companyObj.benefits[request.benefit_id] = {
            color: request.benefit_color,
            name: request.benefit_name,
            values: {}
          };
          companyObj.benefits[request.benefit_id]['values'][request.id] = request.total_value;
        }
        this.checkedRequests.summaryList[request.company_id] = companyObj;
      }
      if (triggerRerender) {
        this.requestSummaryKey++;
      }
    },
    checkAll() {
      if (!this.checkedAllModel) {
        this.checkedRequests.ids = [];
        this.checkedRequests.summaryList = {};
      } else {
        for (let index in this.requests) {
          if (this.checkedRequests.ids.includes(this.requests[index].id) && this.checkedAllModel) {
            continue;
          }
          this.toggleCheck(index, false);
        }
      }
      this.requestSummaryKey++;
    },
    reRenderList() {
      this.checkedRequests.ids = [];
      this.checkedRequests.summaryList = {};
      this.setGeneralData();
      this._loadList();
    },
    placeOrder() {
      let selectedFilters = {
        company: (this.params.company) ? this.filter_options.companies[this.params.company] : null,
        benefit: (this.params.benefit) ? this.filter_options.benefits[this.params.benefit] : null,
        beneficiary: (this.params.beneficiary) ? this.filter_options.beneficiaries[this.params.beneficiary] : null,
        company_address: (this.params.company_address) ? this.filter_options.company_addresses[this.params.company_address] : null,
        department: (this.params.department) ? this.filter_options.departments[this.params.department] : null,
        cost_center: (this.params.cost_center) ? this.filter_options.cost_centers[this.params.cost_center] : null,
        working_point: (this.params.working_point) ? this.filter_options.working_points[this.params.working_point] : null,
        job_title: (this.params.job_title) ? this.filter_options.job_title_list[this.params.job_title] : null,
        benefit_group: (this.params.benefit_group) ? this.filter_options.benefit_groups[this.params.benefit_group] : null,
        start_date: (this.params.start_date) ? moment(this.params.start_date).format('DD/MM/YYYY') : null,
        end_date: (this.params.end_date) ? moment(this.params.end_date).format('DD/MM/YYYY') : null,
      };
      this.$emit('placeOrder', this.checkedRequests.ids, selectedFilters);
    },
    resetFilters() {
      this.params.benefit = null;
      this.params.company = null;
      this.params.beneficiary = null;
      this.params.company_address = null;
      this.params.department = null;
      this.params.cost_center = null;
      this.params.working_point = null;
      this.params.job_title = null;
      this.params.benefit_group = null;
      this.params.start_date = null;
      this.params.end_date = null;
      this.params.only_list = null;
      this.params.sort_by = null;
      this.params.sort_direction = null;
      this.params.selected_platform = null;
    },
    calculateTotal(item) {
      let returnVal = item.total_value;
      if (item.is_gross_taxed) {
        returnVal += item.total_value_cas + item.total_value_cass + item.total_value_tax;
      }
      return returnVal;
    },
    _loadList() {
      this._toggleLoading(true);
      this.httpService.topUpList(this.params)
        .then(function (response) {
          this.requests = response.data.list;
          this.filter_options = response.data.filters;
          this.companySettings = response.data.company_settings;
          this.checkedAllModel = false;
          this._toggleLoading(false);
        }.bind(this))
        .catch(function (error) {
        }.bind(this));
    },
    showDetails(index) {
      let request = this.requests[index];
      let detailStatus = request.status;

      if (typeof this.subTypeTemplates[detailStatus] == 'undefined') {
        return;
      }
      this.detailsId = request.id;
      this.detailsType = detailStatus;
      this.subTypeTemplate = this.subTypeTemplates[detailStatus]
      this.showDetailsForm = true;
      this.toggleTopButtons();
    },
    hideDetails(withReRender = false) {
      this.detailsId = null;
      this.detailsType = null;
      this.showDetailsForm = false;
      this.toggleTopButtons();
      if (withReRender) {
        this.reRenderList();
      }
    },
    _toggleLoading(value, loaderError = false) {
      this.$emit('toggleLoading', value, loaderError)
    },
    toggleTopButtons() {
      this.$emit('toggleTopButtons')
    },
  }
}
</script>
